var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsMNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5052_31244)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5052_31244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 83
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 0H0.5V83H83.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5052_31244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 81.668C63.1 81.668 81 63.768 81 41.668C81 19.568 63.1 1.66797 41 1.66797C18.9 1.66797 1 19.568 1 41.668C1 63.768 18.9 81.668 41 81.668Z",
    fill: "#F2F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 13.2013H56.8334C59.7667 13.2013 62.1667 15.6013 62.1667 18.5346V59.5346C62.1667 62.468 59.7667 64.868 56.8334 64.868H26C23.0667 64.868 20.6667 62.468 20.6667 59.5346V18.5346C20.6667 15.568 23.0667 13.2013 26 13.2013Z",
    fill: "url(#paint0_linear_5052_31244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9667 19.8672H39.3667C40.2667 19.8672 41 20.6005 41 21.5005C41 22.4005 40.2667 23.1339 39.3667 23.1339H25.9667C25.0667 23.1339 24.3334 22.4005 24.3334 21.5005C24.3334 20.5672 25.0667 19.8672 25.9667 19.8672Z",
    fill: "url(#paint1_linear_5052_31244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9666 29.1346H56.0333C56.9333 29.1346 57.6666 29.868 57.6666 30.768C57.6666 31.668 56.9333 32.4013 56.0333 32.4013H25.9666C25.0666 32.4013 24.3333 31.668 24.3333 30.768C24.3333 29.8346 25.0666 29.1346 25.9666 29.1346Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9667 38.4004H56.0334C56.9334 38.4004 57.6667 39.1337 57.6667 40.0337C57.6667 40.9337 56.9334 41.6671 56.0334 41.6671H25.9667C25.0667 41.6671 24.3334 40.9337 24.3334 40.0337C24.3334 39.1004 25.0667 38.4004 25.9667 38.4004Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9666 47.668H56.0333C56.9333 47.668 57.6666 48.4013 57.6666 49.3013C57.6666 50.2013 56.9333 50.9346 56.0333 50.9346H25.9666C25.0666 50.9346 24.3333 50.2013 24.3333 49.3013C24.3333 48.368 25.0666 47.668 25.9666 47.668Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9667 56.9355H56.0334C56.9334 56.9355 57.6667 57.6689 57.6667 58.5689C57.6667 59.4689 56.9334 60.2022 56.0334 60.2022H25.9667C25.0667 60.2022 24.3334 59.4689 24.3334 58.5689C24.3334 57.6355 25.0667 56.9355 25.9667 56.9355Z",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3334 10.3359C63.4334 10.3359 64.3334 9.43594 64.3334 8.33594C64.3334 7.23594 63.4334 6.33594 62.3334 6.33594C61.2334 6.33594 60.3334 7.23594 60.3334 8.33594C60.3334 9.43594 61.2334 10.3359 62.3334 10.3359Z",
    fill: "#C1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 6.33594H75.6667C76.7667 6.33594 77.6667 7.23594 77.6667 8.33594C77.6667 9.43594 76.7667 10.3359 75.6667 10.3359H69C67.9 10.3359 67 9.43594 67 8.33594C67 7.23594 67.9 6.33594 69 6.33594Z",
    fill: "#C1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7 67.2018C55 67.2018 58.9667 65.9018 62.3 63.6685L75.8667 76.6352L80.8 70.9352L67.7 58.4352C70.1334 55.0352 71.5334 50.8685 71.5334 46.3685C71.5334 34.8685 62.2 25.5352 50.7 25.5352C39.2 25.5352 29.8667 34.8685 29.8667 46.3685C29.8667 57.8685 39.2 67.2018 50.7 67.2018ZM68.4667 46.3685C68.4667 56.1018 60.5667 64.0018 50.8334 64.0018C41.1 64.0018 33.2 56.1018 33.2 46.3685C33.2 36.6352 41.1 28.7352 50.8334 28.7352C60.5667 28.7352 68.4667 36.6018 68.4667 46.3685Z",
    fill: "#C1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8333 64.3359C60.8666 64.3359 69 56.2693 69 46.3359C69 36.4026 60.8666 28.3359 50.8333 28.3359C40.8 28.3359 32.6666 36.4026 32.6666 46.3359C32.6666 56.2693 40.8 64.3359 50.8333 64.3359Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9667 46.3333L58.3667 41.9667C58.7667 41.5333 59 40.9667 59 40.3667C59 39.7667 58.7334 39.2 58.3334 38.7667C57.9 38.3333 57.3334 38.1 56.7334 38.1C56.1334 38.1 55.5667 38.3 55.1334 38.7333L50.7334 43.1L46.3334 38.7333C46.1334 38.5 45.8667 38.3333 45.6 38.2C45.3334 38.0667 45 38 44.7 38C44.4 38 44.1 38.0667 43.8 38.1667C43.5 38.2667 43.2667 38.4667 43.0334 38.6667C42.8 38.8667 42.6334 39.1333 42.5334 39.4333C42.4334 39.7333 42.3667 40.0333 42.3667 40.3333C42.3667 40.6333 42.4334 40.9333 42.5667 41.2333C42.7 41.5 42.8667 41.7667 43.1 41.9667L47.5 46.3333L43.1 50.7C42.8667 50.9 42.7 51.1667 42.5667 51.4333C42.4334 51.7 42.3667 52 42.3667 52.3333C42.3667 52.6333 42.4334 52.9333 42.5334 53.2333C42.6334 53.5333 42.8334 53.7667 43.0334 54C43.2667 54.2 43.5 54.4 43.8 54.5C44.1 54.6 44.4 54.6667 44.7 54.6667C45 54.6667 45.3 54.6 45.6 54.4667C45.8667 54.3333 46.1334 54.1667 46.3334 53.9333L50.7334 49.5667L55.1334 53.9333C55.5667 54.3333 56.1334 54.5333 56.7334 54.5C57.3334 54.4667 57.8667 54.2333 58.3 53.8333C58.7 53.4333 58.9667 52.8667 58.9667 52.3C59 51.7333 58.7667 51.1667 58.4 50.7L53.9667 46.3333Z",
    fill: "url(#paint2_linear_5052_31244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8667 76.6004L80.8 70.9004L81.5334 71.6004C82.2667 72.3004 82.6667 73.2337 82.7334 74.2671C82.7667 75.3004 82.4334 76.3004 81.8 77.0337C81.1334 77.8004 80.2334 78.2337 79.2667 78.3004C78.3 78.3337 77.3334 78.0004 76.6334 77.3004L75.8667 76.6004Z",
    fill: "#C1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 75C6.60457 75 7.5 74.1046 7.5 73C7.5 71.8954 6.60457 71 5.5 71C4.39543 71 3.5 71.8954 3.5 73C3.5 74.1046 4.39543 75 5.5 75Z",
    fill: "#C1D5E8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5052_31244",
    x1: 41.4229,
    y1: 13.1866,
    x2: 41.4229,
    y2: 64.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5052_31244",
    x1: 28.5926,
    y1: 22.3172,
    x2: 29.1363,
    y2: 18.9079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5052_31244",
    x1: 46.6174,
    y1: 50.5,
    x2: 55.3528,
    y2: 39.7843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5052_31244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsMNoResults);
export default __webpack_public_path__ + "static/media/es-m-no-results.50c5e9e21fe3571bfc06a2f3673fd556.svg";
export { ForwardRef as ReactComponent };